<template>
	<div>
		<h1 class="page-header"><i class="fa-solid fa-house-chimney-user"></i> Hír szerkesztése <small></small></h1>
		<div class="row">
			<div class="col-lg-6">
				<panel title="Alapadatok">
                    <form @submit.prevent="updateNews">
                        <div class="form-group">
                            <label for="nameInput" class="form-label">Cím</label>
                            <input type="text" class="form-control" v-model="news.name" :class="{'is-invalid':errors.name}" id="nameInput"/>main
                            <div class="invalid-feedback" v-if="errors.name">
                                {{errors.name[0]}}
                            </div>
                        </div>
                        
                        <div class="row mt-3">
                            <div class="col-6 px-auto">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" :class="{'is-invalid':errors.landing}" type="checkbox" id="landingInput" v-model="news.landing" :true-value="1" :false-value="0"/>
                                    <label class="form-check-label form-label" for="landingInput">Landing</label>
                                </div>
                                <div class="invalid-feedback" v-if="errors.landing">
                                    {{errors.landing[0]}}
                                </div>
                            </div>
                        </div>
                        
                        <div class="form-group mt-2">
                            <label for="descriptionInput" class="form-label">Leírás</label>
                            <textarea cols="30" class="form-control" style="height:400px" v-model="news.description" :class="{'is-invalid':errors.description}" id="descriptionInput"></textarea>
                            <div class="invalid-feedback" v-if="errors.description">
                                {{errors.description[0]}}
                            </div>
                        </div>
                        <div slot="footer" class="text-end mt-2">
                            <button class="btn btn-icon btn-lg btn-success" title="mentés" :disabled="loading">
                                <i v-if="loading" class="fa-solid fa-cog fa-spin"></i>
                                <i v-else class="fa-solid fa-floppy-disk"></i>
                            </button>
                        </div>
                    </form>
				</panel>
				
			</div>
			<div class="col-lg-6">
				<panel title="Képek">
					<Loading v-if="!news"></Loading>
					<ImageUpload v-else parent_model="News" :model_id="news.id"></ImageUpload>
				</panel>
				
			</div>
		</div>
	</div>
</template>

<script>
	import ImageUpload from '../../components/ImageUpload';
	import News from '../../apis/News';
	export default {
		name:'EditNews',
		components:{
			ImageUpload
		},
		data() {
			return {
				news:null,
				loading:false,
				errors:[],
			}
		},
		created() {
			News.show(this.$route.params.id)
			.then(response => {
				this.news = response.data;
			}).catch(() => {
				this.news = {notfound:true}
			});			
		},
		methods: {
			updateNews(){
				this.loading = true;
				News.update(this.$route.params.id,this.news)
				.finally(() => {
					this.loading = false;
				})
			}
		}
	};
</script>